import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import playnowarrow from "../../../../../Images/NewUI/playnowbtnarrow.png";
import { PaymelearnSaga, PaymelearnSagaCredit } from "../../../../../Redux/Manual_Kyc_Details/action";
import ToggleBar from "../../../DashBoardNew/ToggleBar";

const PaymeLearn = (props) => {
  const [activeState, setActiveState] = useState("A");
  const [numbers, setNumbers] = useState({ num1: 0, num2: 0 });

  const generateRandomNumbers = () => {
    const min = 5000;
    const max = 10000;
    const randomNum1 = Math.floor(Math.random() * (max - min + 1)) + min;
    const randomNum2 = Math.floor(Math.random() * (max - min + 1)) + min;
    setNumbers({ num1: randomNum1, num2: randomNum2 });
  };

  useEffect(() => {
    generateRandomNumbers()
  }, []); 

  const paymeLearnRedirection = () => {
    const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    
    props.PaymelearnSaga(token)
   
      .then((res) => {
        // console.log(res.data.url, "paymelearnSaga URL");
        const url = res.data.url;
        setTimeout(() => {
          window.open(url, "_blank");
        }, 100);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        const error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

  const paymeLearnCreditRedirection = () => {
    const token = props?.user?.User?.token || localStorage.getItem("gpay_token");

    props.PaymelearnSagaCredit(token)
      .then((res) => {
        // console.log(res.data.url, "paymelearnSagaCredit URL");
        const url = res.data.url;
        setTimeout(() => {
          window.open(url, "_blank");
        }, 100);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        const error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <div className="paymelearnheader shadowline flex sticky-header align-center ">
        <a onClick={() => { window.location.href = "/dashboard"; }}>
          <img src={arrowleft} alt="Back" style={{ marginRight: 30, marginLeft:30 }} />
        </a>
        <div>
          <span className="">PayMe Learn</span>
        </div>
      </div>

      <ToggleBar activeState={activeState} />

      <div className="paymelearn-container  paymelearncardfix">
        <span className="paymelearn-title">Learn Finance with fun gameplay!</span>
        <div className="gradient-divider"></div>

        <div onClick={paymeLearnCreditRedirection} className="paymelearn-card credit-score-saga">
        
          <div  className="card-content displayflex playnow-btn">
            {/* <img src={CreditLimitimg} width={"178px"} style={{ marginRight: "11px" }} alt='creditlimit' /> */}
            
            
            <div className='flex' >
              {/* <span className="card-title">Credit Score <br /> Saga</span> */}
              <br />
              {/* <span className="card-subtitle">Unlock credit secrets</span> <br /> */}
              <span className='livenumber'><span>{numbers.num1}</span> people playing now</span>
              <button  style={{ letterSpacing: '0.0px' }} className="play-now-btn displayflex mthere-19 ">
                PLAY NOW
                <img src={playnowarrow} width={"10px"} style={{ marginLeft: '12px' }} />
              </button>

            </div>
          </div>
        </div>

        <div onClick={paymeLearnRedirection}  className="paymelearn-card-fitness credit-score-saga">
          <div className="card-content displayflex playnow-btn">
            {/* <img src={fitnessimg} width={"178px"} style={{ marginRight: "11px" }} alt='fitness' /> */}
            <div className='flex' >
              {/* <span className="card-title">Financial Fitness <br /> Challenge</span> */}
              
              {/* <span className="card-subtitle">Test your financial knowledge</span> <br /> */}
              <span className='livenumber'><span>{numbers.num2}</span> people playing now</span>
              <button style={{ letterSpacing: '0.0px' }} className="play-now-btn displayflex mttopp-5">PLAY NOW
              <img src={playnowarrow} width={"10px"} style={{ marginLeft: '12px' }} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, {
  PaymelearnSaga,
  PaymelearnSagaCredit,
})(PaymeLearn);
